import React from "react";

import { EnablementFlagsModule } from "../../../modules/EnablementFlags";
import DashboardLayout from "../../../molecules/DashboardLayout";

const EnablementFlags = () => {
  return (
    <DashboardLayout>
      <EnablementFlagsModule />
    </DashboardLayout>
  );
};

export default EnablementFlags;
